<template>
  <div class="survey">
    <div class="row">
      <member-list class="pt-3" :facets="supportFacets" :query="supportQuery" :fields="supportFields"
                   :title="this.$t('labels.supporters')"></member-list>
    </div>
  </div>
</template>
<script>
import MemberList from '@/components/lists/member/MemberList';

export default {
  name: 'history',
  props: {
    id: Number,
    localOffice: Object,
  },
  components: {
    MemberList,
  },
  computed: {
    supportQuery() {
      return {
        query: {
          bool: {
            must: [
              {
                match: {
                  'office.raw': this.localOffice.office.label,
                },
              },
              {
                nested: {
                  path: 'support',
                  query: {
                    exists: {
                      field: 'support.label',
                    },
                  },
                },
              },
            ],
          },
        },
      };
    },
  },
  data() {
    return {
      supportFacets: [
        {
          level: 1,
          id: 'officeFilter',
          field: 'office.raw',
          label: this.$t('labels.victim-support-centres'),
          placeholder: this.$t('labels.victim-support-centre'),
          type: 'list',
        },
        {
          level: 1,
          id: 'localofficeFilter',
          field: 'localoffice.raw',
          label: this.$t('labels.local-office'),
          placeholder: this.$t('labels.local-office'),
          type: 'list',
        },
        {
          level: 1,
          id: 'categoryFilter',
          field: 'category.raw',
          label: this.$t('labels.category'),
          placeholder: this.$t('labels.all-categories'),
          type: 'list',
          small: true,
        },
        {
          level: 1,
          id: 'nameFilter',
          field: 'full_name',
          label: this.$t('labels.name'),
          placeholder: `${this.$t('labels.name')}..`,
          type: 'search',
        },
        {
          level: 1,
          id: 'idFilter',
          field: 'id',
          label: this.$t('labels.member-number'),
          placeholder: `${this.$t('labels.member')} #..`,
          type: 'search',
        },
        {
          level: 2,
          id: 'genderSubFilter',
          field: 'gender.raw',
          label: this.$t('labels.gender'),
          placeholder: this.$t('labels.gender'),
          type: 'list',
          small: true,
        },
        {
          level: 2,
          id: 'supportSubFilter',
          nestedField: 'support',
          field: 'support.label.raw',
          label: this.$t('labels.support-type'),
          placeholder: this.$t('labels.support-type'),
          type: 'list',
          small: true,
        },
        {
          level: 2,
          id: 'volunteerSubFilter',
          field: 'volunteer.raw',
          label: 'Volontärstatus',
          placeholder: 'Volontärstatus',
          type: 'list',
          small: true,
        },
        {
          level: 2,
          id: 'languageSubFilter',
          nestedField: 'language',
          field: 'language.label.raw',
          label: this.$t('labels.language-skills'),
          placeholder: this.$t('labels.language-skills'),
          type: 'list',
          small: true,
        },
      ],

      supportFields: [
        {
          key: 'id',
          sort_field: 'id',
          label: '#',
          width: 6,
        },
        {
          key: 'first_name',
          sort_field: 'first_name.raw',
          label: this.$t('labels.first-name'),
          width: 11,
        },
        {
          key: 'last_name',
          sort_field: 'last_name.raw',
          label: this.$t('labels.last-name'),
          width: 11,
        },
        {
          key: 'office',
          sort_field: 'office.raw',
          label: this.$t('labels.victim-support-centre'),
          width: 12,
        },
        {
          key: 'support_list',
          sort_field: 'support_list.raw',
          label: this.$t('labels.support-type'),
          width: 14,
        },
       
        {
          key: 'language_list',
          sort_field: 'language_list.raw',
          label: this.$t('labels.language-skills'),
          width: 16,
        },

        {
          key: 'mobile',
          sort_field: 'mobile.raw',
          label: this.$t('labels.mobile'),
          width: 12,
        },
        {
          key: 'email',
          sort_field: 'email.raw',
          label: '',
          width: 5,
        },
      ],
    };
  },
};
</script>
